import React from 'react';
import { LaptopOutlined, NotificationOutlined, UserOutlined } from '@ant-design/icons';
import { Breadcrumb, Layout, Menu, theme } from 'antd';
import Markdown, { RuleType } from 'markdown-to-jsx';

const { Header, Content, Sider } = Layout;


const about={en:`
# About Port Emissions Inventory Tool (PEIT)

## Overview

The Port Emissions Inventory Tool (PEIT) is a comprehensive web application designed to calculate emissions at ports. It helps port authorities, environmental agencies, and other stakeholders to accurately assess the environmental impact of various activities within port areas.

## Key Features

- **Comprehensive Emissions Calculation**: PEIT includes seven distinct worksheets, each representing different types of port activities such as marine, rail, and more.  
- **User-Friendly Interface**: Built using React and Ant Design (AntD), PEIT provides a seamless and intuitive user experience.  
- **Cloud-Based Processing**: Leveraging Amazon Web Services (AWS) Cloud Services, the tool ensures robust and scalable performance.

## How It Works

1. **Questionnaire Completion**: Users can fill out a detailed questionnaire that covers various port activities. Each worksheet corresponds to a specific activity type.  
   - **Excel Import**: The questionnaire can be filled out in Excel and imported into the tool.  
   - **Web Application Editing**: The imported questionnaire can be edited directly within the web application.  
2. **UUID Assignment**: The completed questionnaire is assigned a unique identifier (UUID) to ensure secure and accurate tracking.  
3. **AWS Lambda Processing**: The questionnaire data is sent to AWS Lambda functions, which use Python (Pandas) for emissions calculations.  
4. **Secure Data Handling**: The calculated emissions data is saved in an S3 bucket as an Excel sheet. Only the web browser has knowledge of the UUID, ensuring data privacy.  
5. **Temporary Access**: The output data (Excel sheet) is accessible for download for a limited period (a few minutes) to ensure security and data integrity. **The data is not saved on our servers.**

## Data Privacy and Security

- **UUID-Based Tracking**: Each questionnaire is assigned a unique UUID known only to the web browser, ensuring data privacy.  
- **Temporary Data Storage**: Emissions data is stored in an S3 bucket and is only accessible for a few minutes, after which it is automatically deleted.  
- **Secure Data Transfer**: All data transfers between the web app and AWS services are encrypted to ensure security.

## Technologies Used

- **Frontend**: React, Ant Design (AntD)  
- **Backend**: AWS Lambda, AWS S3  
- **Programming Languages**: JavaScript, Python (Pandas)

## User Manual

The user manual provides instructions for completing the questionnaire, importing an Excel file, editing data in the web application, running emissions calculations, and downloading results.

Users are encouraged to review this document before using PEIT to better understand the questionnaire structure, required data inputs, and steps involved in generating a complete emissions inventory.

[PEIT Instruction Manual](https://peit-oiep.s3.amazonaws.com/public/template/PEIT_Instruction%20Manual.pdf).

---
`, fr:`
# À propos de l'outil d'inventaire des émissions portuaires (OIEP)

## Vue d'ensemble

L'outil d'inventaire des émissions portuaires (OIEP) est une application web complète conçue pour calculer les émissions dans les ports. Il aide les autorités portuaires, les agences environnementales et les autres parties prenantes à évaluer avec précision l'impact environnemental des différentes activités dans les zones portuaires.

## Caractéristiques principales

1. **Calcul exhaustif des émissions** : L’OIEP comprend sept feuilles de calcul distinctes, chacune représentant différents types d'activités portuaires telles que le transport maritime, le transport ferroviaire, etc.  
2. **Interface conviviale** : Construit à l'aide de React et Ant Design (AntD), l'OIEP offre une expérience utilisateur transparente et intuitive.  
3. **Traitement basé sur les services infonuagiques** : S'appuyant sur les services infonuagiques d'Amazon Web Services (AWS), l'outil garantit des performances robustes et évolutives.

## Fonctionnement

1. **Remplissage du questionnaire** : Les utilisateurs peuvent remplir un questionnaire détaillé qui couvre diverses activités portuaires. Chaque feuille de calcul correspond à un type d'activité spécifique.  
   - **Importation d'Excel** : Le questionnaire peut être rempli dans Excel et importé dans l'outil.  
   - **Edition d'une application web** : Le questionnaire importé peut être édité directement dans l'application web.  
2. **Attribution d'un UUID** : Le questionnaire rempli se voit attribuer un identifiant unique (UUID) afin de garantir un suivi sécurisé et précis.  
3. **Traitement AWS Lambda** : Les données du questionnaire sont envoyées à des fonctions AWS Lambda, qui utilisent Python (Pandas) pour les calculs d'émissions.  
4. **Traitement sécurisé des données** : Les données d'émissions calculées sont enregistrées dans un compartiment AWS S3 sous forme de feuille Excel. Seul le navigateur web a connaissance de l'identifiant unique universel, ce qui garantit la confidentialité des données.  
5. **Accès temporaire** : Les données de sortie (feuille Excel) peuvent être téléchargées pendant une période limitée (quelques minutes) afin de garantir la sécurité et l'intégrité des données. **Les données ne sont pas enregistrées sur nos serveurs.**

## Confidentialité des données et sécurité

- **Suivi basé sur l'UUID** : Chaque questionnaire se voit attribuer un identifiant unique universel connu uniquement du navigateur web, ce qui garantit la confidentialité des données.  
- **Stockage temporaire des données** : Les données relatives aux émissions sont stockées dans un compartiment AWS S3 et ne sont accessibles que pendant quelques minutes, après quoi elles sont automatiquement supprimées.  
- **Transfert de données sécurisé** : Tous les transferts de données entre l'application web et les services AWS sont cryptés pour garantir la sécurité.

## Technologies utilisées

- **Interface utilisateur**: React, Ant Design (AntD)  
- **Application serveur**: AWS Lambda, AWS S3  
- **Langages de programmation** : JavaScript, Python (Pandas)

## Manuel de l’utilisateur

Le manuel de l’utilisateur fournit les instructions nécessaires pour remplir le questionnaire, importer un fichier Excel, modifier les données dans l’application web, lancer les calculs et télécharger les résultats.

Il est recommandé de consulter ce document avant d’utiliser l’OIEP afin de mieux comprendre la structure du questionnaire, les types de données requis et les étapes à suivre pour générer un inventaire d’émissions complet.

[Manuel de l’utilisateur de l’OIEP](https://peit-oiep.s3.amazonaws.com/public/template/OIEP_Manuel%20de%20l%E2%80%99utilisateur.pdf).

---
`
}

export default ({lng})=>{
  const items=[{
  key: "a",
  label: "Menu A",
}];
 const [current, setCurrent] = React.useState('a');
 const onClick = (e) => {
    
    setCurrent(e.key);
  };
  return (
    <Layout>   
    
        <Content style={{padding:16}}>
          <Markdown
            children = { about[lng]||"" }
            />
            
        </Content>
    </Layout>
    )
}